// extracted by mini-css-extract-plugin
export var dividerLine = "_5q-3";
export var itemImage = "_5q-9";
export var lightDivider = "_5q-4";
export var modalContent = "_5q-5";
export var modalContentCompact = "_5q-6";
export var productCard = "_5q-a";
export var productImage = "_5q-b";
export var productImageCompact = "_5q-7";
export var productImagePlaceholder = "_5q-c";
export var productImagePlaceholderCompact = "_5q-8";
export var progressBarBackground = "_5q-1";
export var progressBarContainer = "_5q-0";
export var progressBarFill = "_5q-2";